export default __webpack_public_path__ + "static/media/Cross.c1ddb5c6.svg";